import React from 'react'
import {IoInformationCircle} from 'react-icons/io5'
import useTranslate from 'modules/local/useTranslate'

// Khối "Quyền lợi khi hoàn tất liên kết cây hệ thống" - dùng chung cho cả 3 trạng thái (không linh
// hoạt xong vẫn để người dùng biết vì sao nên hoàn tất việc khai báo).
//
// Màu XANH LÁ (green) trước đây SAI ngữ nghĩa - đây chỉ là ghi chú/thông tin tham khảo (giống khối
// "Ghi chú"/"Hướng dẫn" màu xanh dương info đã dùng ở nơi khác trong app, vd Lookup modal, block
// "Hướng dẫn" cũ), không phải trạng thái "đã hoàn tất/active" (chỉ node cuối trên cây + banner khi
// verified mới nên dùng xanh lá).
const AssociationBenefitsList = ({benefitKeys = []}) => {
    const t = useTranslate()
    return (
        <div className="p-4 rounded-xl border border-blue-200 bg-blue-50 flex flex-col gap-2.5">
            <div className="flex items-center gap-1.5 font-bold text-sm text-blue-700 uppercase tracking-wide">
                <IoInformationCircle size={16} className="flex-shrink-0"/>
                {t('benefits after completing the system link')}
            </div>
            {benefitKeys.map((key) => (
                <div key={key} className="flex items-start gap-2">
                    <span className="flex-shrink-0 mt-1.5 rounded-full bg-blue-400" style={{width: 5, height: 5}}/>
                    <span className="text-sm text-color-700 leading-snug">{t(key)}</span>
                </div>
            ))}
        </div>
    )
}

export default AssociationBenefitsList
